/**
 * Font sizes used for component
 * @type {Object}
 */
export const ComponentFontSizes = {
  SMALL: 'small',
  LARGE: 'large',
  XXLARGE: 'xxlarge'
};

export const Colors = {
  BLUE: 'blue',
  YELLOW: 'yellow',
  GREEN: 'green',
  PURPLE: 'purple',
  RED: 'red',
  GRAY: 'gray',
  GRAY_DARK: 'gray-dark',
  WHITE: 'white'
};

/**
 * Font sizes used for component
 * @type {Object}
 */
export const ComponentFontWeights = {
  NORMAL: 'normal',
  BOLD: 'bold'
};

export const KeyCodesUppercase = {
  ESCAPE: 27,
  ARROW_RIGHT: 39,
  ARROW_LEFT: 37
};

export const MENTION_TEMPLATE_REGEXP = /@{\s?"type"\s?:\s?"(.+?(?="\s?))"\s?,\s?"id"\s?:\s?"[a-zA-Z0-9^]*"\s?,\s?"name"\s?:\s?"(.+?(?="\s?}))"\s?}/;
export const MENTION_ID_REGEXP = new RegExp(/"id":\s?"([a-zA-Z0-9^]*)"\s?/g);
export const MENTION_DISPLAY_REGEXP = new RegExp(/"name"\s?:\s?"(.+?(?="\s?}))"\s?/g);
export const EMAIL_REGEXP = new RegExp(/([\w\.\-_]+)?\w+@[\w-_]+(\.\w+){1,}/i);

export const DateFormats = {
  SHORT_DATE_FORMAT: 'MMM D, YYYY',
  SHORT_DATE_NO_YEAR_FORMAT: 'MMM D',
  SHORT_DATE_HOUR_NO_YEAR_FORMAT: 'MMM D, h:mma',
  SHORT_DATE_SPACED_HOUR_NO_YEAR_FORMAT: 'MMM D, h:mm A'
};

export const ELLIPSIS_CHAR = '\u2026';

export const NO_AVATAR_SUFFIX = 'user_X50.png';

export const DEFAULT_AVATAR =
  'data:image/png;base64,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';

export const AssigneeTypes = {
  USER: 'USER',
  COMPANY: 'COMPANY',
  ROLE: 'ROLE'
};

export const mobileWidthThreshold = 420;

// Should be same values as in _AccountProjectPicker.scss
export const accountProjectPickerWidth = 360;
export const accountProjectPickerListHeight = 560;
export const defaultAccountProjectPickerRowHeight = 60;

export const REGIONS = {
  US: 'US',
  EMEA: 'EMEA',
  FEDRAMP: 'FEDRAMP'
};

export const ENVS = {
  DEV: 'DEV',
  QA: 'QA',
  STAGING: 'STAGING',
  PROD: 'PROD'
};
